module.exports = __webpack_public_path__ + "img/setxrm-nedir-setxrm-avantajlari-nelerdir.979bd94f.png";